import {
  archive,
  codex,
  labelSourceDelete,
  labelSourceUpdate,
  labelSourceUpdateTooltip,
  privateSource,
  valueArchive,
  valueDatabase,
  valuePrivate,
} from "_constants";
import { PrimeIcons } from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { useRef } from "react";

export const SourceTypeChip = ({
  type,
  name,
  stateUpdate,
}: {
  type: "CODEX" | "ARCHIVE" | "PRIVATE";
  stateUpdate?: "AGGIORNATO" | "DEPRECATO" | "ELIMINATO";
  name?: string;
}) => {
  const chipRef = useRef(null);
  return (
    <div
      className={`container-visibility ${
        stateUpdate === "ELIMINATO"
          ? "delete-source"
          : type === "CODEX"
          ? valueDatabase
          : type === "ARCHIVE"
          ? valueArchive
          : valuePrivate
      }`}
      ref={chipRef}
    >
      <i
        className={
          type === "CODEX"
            ? PrimeIcons.DATABASE
            : type === "ARCHIVE"
            ? PrimeIcons.FOLDER_OPEN
            : PrimeIcons.UPLOAD
        }
      ></i>
      <Tooltip target={chipRef} mouseTrack mouseTrackLeft={10}>
        {stateUpdate === "ELIMINATO" || stateUpdate === "DEPRECATO" ? (
          <ul className="list-source-update">
            <li>{name}</li>
            {stateUpdate === "ELIMINATO" && <li>{labelSourceDelete}</li>}
            {stateUpdate === "DEPRECATO" && <li>{labelSourceUpdateTooltip}</li>}
          </ul>
        ) : name ? (
          name
        ) : type === "CODEX" ? (
          codex
        ) : type === "ARCHIVE" ? (
          archive
        ) : (
          privateSource
        )}
      </Tooltip>
      <small className="small font-weight-600 ellipsis chip-name">
        {`${stateUpdate === "DEPRECATO" ? `(${labelSourceUpdate}) ` : ""}${
          name
            ? name
            : type === "CODEX"
            ? codex
            : type === "ARCHIVE"
            ? archive
            : privateSource
        }`}
      </small>
    </div>
  );
};
